<div class="karten-zoom" [class.karten-zoom--kompakt]="kompakt">
  <button type="button" class="karten-zoom__button"
    title="Karten verkleinern"
    aria-label="Karten verkleinern"
    [disabled]="kartenZoom.amMinimum"
    (click)="kartenZoom.kleiner()">
    <mat-icon>remove</mat-icon>
  </button>
  <button type="button" class="karten-zoom__value"
    title="Auf Standardgröße zurücksetzen"
    (click)="kartenZoom.zuruecksetzen()">{{ kartenZoom.wert }}%</button>
  <button type="button" class="karten-zoom__button"
    title="Karten vergrößern"
    aria-label="Karten vergrößern"
    [disabled]="kartenZoom.amMaximum"
    (click)="kartenZoom.groesser()">
    <mat-icon>add</mat-icon>
  </button>
</div>
